<template>
  <div id="newPay" v-show="userStateGot">
    <div class="content">
      <div class="nav-bar">
        <div class="nav-bar-l">
          <img src="https://web-data.zmlearn.com/image/9Y2UtXePWVb3ociaEsByLV/pic_logo.png" />
        </div>
      </div>
      <div class="middle">
        <div class="first">
          <div class="img-box">
            <img :src="topbanPic" class="topban" />
            <div class="bottom-image"></div>
          </div>
          <div class="lesson-form-box">
            <div class="btn-fake" @click="toggleDialogForm('2','50元领课')"></div>
          </div>
        </div>
        <div class="third"></div>
        <div class="four">
          <div class="swiper-box">
            <zm-swiper swipeid="swipe" :autoplay="3000" :loop="true" effect="slide" ref="swiper">
              <div class="swiper-slide intro1" slot="swiper-con"></div>
              <div class="swiper-slide intro2" slot="swiper-con"></div>
            </zm-swiper>
          </div>
        </div>
        <div class="seventh">
          <div class="seventh-btn" @click="toggleDialogForm('3','50元领课')"></div>
        </div>
        <zm-footer style="width: 100%"></zm-footer>
        <div class="seventh seventhFix" v-show="showBottomBtnFixed">
          <div class="seventh-btn" @click="toggleDialogForm('3','50元领课')"></div>
        </div>
      </div>
    </div>

    <div class="dialog-form" v-if="showDialogForm">
      <div class="lesson-form-content" ref="lessonFormContent">
        <div class="lesson-form-box">
          <lesson-form
            type="newChannel"
            :btnText="btnText"
            :TitleText="TitleText"
            :needCodeStatus="true"
            :noRefund="true"
            :appId="appId"
            :openId="openId"
            @closeDialog="toggleDialogForm"
          ></lesson-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lessonForm from './lesson-form'
import zmFooter from '@/components/zm-footer/zm-footer'
import urlConfig from '@/config'
import { KidsWeChatShare } from '@/assets/js/shareMessage'
import { wxfuncUrlDel } from '@/utils/util'
import api from '@/api'
import Toast from "@/base/toast/toast";

export default {
  components: {
    lessonForm,
    zmFooter,
  },
  data() {
    return {
      showDialog: false,
      showDialogForm: false,
      showBottomBtnFixed: false,
      activeTab: 1,
      TitleText: '',
      btnText: '',
      appId: '',
      topbanPic: 'https://web-data.zmlearn.com/image/sbRmW9kvq8muQSqKgsjP6a/huanglei.png',
      openId: '',
      LOGINFO: {},
      userStateGot: true,
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!to.query.openId) {
      location.href = `${urlConfig.kidAppGateway}/kids/api/wxmp/mp/web/auth/learning/center/userinfo?redirect=${encodeURIComponent(location.href)}&needLogin=false&needToken=true`;
    }
    next();
  },
  created() {
    const {openId = undefined, sUId = '' } = this.$route.query;
    if (openId) {
      this.openId = openId;
      // this.getUserPaidInfo();
      const user_type = !sUId && 1 || 0;
      this.initLogInfo(openId, user_type);
    }
    console.log(222222222222, JSON.stringify(this.$route.query));
  },
  mounted() {
    wxfuncUrlDel(this);
    this.$nextTick( async () => {
      window.addEventListener('scroll', this.checkPosition, false);
      this.checkPosition();
      const {channel_code, channel_keyword } = this.$route.query;
      this.appId = await KidsWeChatShare({
        title: '掌门少儿',
        desc: '免费领取价值398元试听课',
        imgUrl: 'https://activity-static.zmlearn.com/m/zmsr.png',
        link: `${location.origin}/new-pay?channel_code=${channel_code}&channel_keyword=${channel_keyword}`
      }, ['menuItem:copyUrl']);
    });
    this.sendEvent(this.LOGINFO['1']);
  },
  destroyed() {
    window.removeEventListener('scroll', this.checkPosition)
  },
  methods: {
    sendEvent(data) {
        ZM_JSSDK && ZM_JSSDK.sendEvent(data);
    },
    initLogInfo(openId, user_type) {
      this.LOGINFO = {
        '1': {
          eventId: 'enter_kid_act29_homepage',
          eventParam: {
            name: '进入|少儿|活动|立即领取主页面',
            desc: '进入9.9地推返现领取主页面触发',
            openId,
            user_type, // user_type,用户类型,1：自发用户、2：被邀请用户；
          }
        },
        '2': {
          eventId: 'click_kid_act29_ljlq',
          eventParam: {
            name: '点击|少儿|活动|点击立即领取',
            desc: '点击主页面的立即领取按钮买按钮触发',
            openId,
            position: 1, // 页面中央
          }
        },
        '3': {
          eventId: 'click_kid_act29_ljlq',
          eventParam: {
            name: '点击|少儿|活动|点击立即领取',
            desc: '点击主页面底部的立即购买按钮触发',
            openId,
            position: 2, // 悬浮底部
          }
        }
      }
    },
    toggleDialogForm(type, btn) {
      type && this.sendEvent(this.LOGINFO[type]);
      this.showDialogForm = !this.showDialogForm;
      this.btnText = '9.9元立即购买';
      // noinspection CssNoGenericFontName
      this.TitleText = '<div style="color:#333;font-size:0.53rem;font-weight:normal;font-family:"PingFangSC-Medium">限时<span style="color: #ff6e35; padding: 0 0.1rem;">9.9元</span>领取</div>'
    },
    checkPosition() {
      if (window.scrollY < 350) {
        this.showDialog = false;
        this.showBottomBtnFixed = false
      } else if (window.scrollY > 350 && window.scrollY < 1240) {
        this.showDialog = true;
        this.showBottomBtnFixed = true
      } else if (window.scrollY > 1240) {
        this.showDialog = false;
        this.showBottomBtnFixed = false
      }
    },
    // 获取用户支付信息（是否购买过，邀请人数，返现金额）
    async getUserPaidInfo() {
      try {
        const {channel_code: c_code, channel_keyword: c_key } = urlConfig.codeKey9Point9;
        const { channel_keyword = c_key, channel_code = c_code, accessToken = '', openId } = this.$route.query;
        if (!accessToken) {
          this.userStateGot = true;
          return;
        }
        const {data: {data: { buy }, code, message}} = await api.KidUserHasPaid(accessToken);
        if (code * 1 === 0) {
          if (buy) {
            this.$router.replace({
              path: '/new-pay-share',
              query: {
                openId,
                accessToken,
                channel_keyword,
                channel_code
              }
            })
          }
        } else {
          console.warn(message);
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.userStateGot = true;
      }
    }
  }
}
</script>
<style lang="scss">
#newPay {
  .four {
    .swiper-container {
      width: 100%;
      height: 100%;
      z-index: 0;
      .swiper-pagination {
        bottom: px2rem(50);
        .swiper-pagination-bullet {
          background: #ffcf97;
          transition: all 0.25s ease;
        }
        .swiper-pagination-bullet-active {
          width: px2rem(50);
          height: px2rem(16);
          border-radius: px2rem(30);
          background: #ffad10;
          transition: all 0.25s ease;
        }
      }
    }
    .swiper-slide {
      height: px2rem(612);
      vertical-align: bottom;
      background-size: contain !important;
    }
  }
  .first {
    .swiper-slide {
      img {
        height: px2rem(394);
        width: 100%;
        vertical-align: bottom;
      }
    }
    .lesson-form-box {
      width: px2rem(732) !important;
      height: px2rem(1003) !important;
      /*background: url("https://web-data.zmlearn.com/image/81UyDAEH9Bz4y3ADuGyWyw/form-fake.png") no-repeat center;*/
      background: url("https://web-data.zmlearn.com/image/513p9hCmNUveEDjSHAAknP/%EF%BF%A59.9m.png") no-repeat center;
      background-size: cover;
      .btn-fake {
        position: absolute;
        bottom: px2rem(150);
        left: px2rem(70);
        width: px2rem(600);
        height: px2rem(130);
      }
    }
  }
  .bottom-area {
    padding: 0;
  }
  .dialog-form {
    .lesson-form {
      .form-content {
        .flex-item {
          position: relative;
          .arrow {
            position: absolute;
            display: inline-block;
            width: px2rem(25);
            height: px2rem(15);
            background: url("../../../../assets/image/home/newPopFromArrow.png")
              no-repeat center !important;
            background-size: contain !important;
            right: px2rem(50);
            top: px2rem(50);
          }
          .grade-arrow {
            top: px2rem(40);
            right: 3.9rem;
          }
          .subject-arrow {
            top: px2rem(40);
            right: px2rem(20);
          }
        }
        .grade,
        .subject,
        input {
          font-size: 95%;
          background: #eee;
          border: none;
          border-radius: px2rem(10);
          text-indent: px2rem(30);
          color: #202020;
          &::-webkit-input-placeholder {
            color: #999;
          }
          &::-moz-placeholder {
            color: #999;
          }
        }
        .grade {
          width: 55% !important;
          position: relative;
          color: #202020;
        }
        .subject {
          width: 44% !important;
          position: relative;
          color: #202020;
        }
      }
      .form-protocol {
        .checkoutImg {
          width: px2rem(27);
          height: px2rem(27);
          margin-right: px2rem(20);
        }
        .form-protocol-text {
          .high-light {
            color: #ff6e35;
          }
        }
      }
      .zm-btn {
        position: relative;
        width: px2rem(450);
        height: px2rem(106);
        background: url("../../../../assets/image/home/newPopFormBtnBg.png") no-repeat
          center;
        background-size: cover;
        margin: px2rem(20) auto;
        span {
          position: absolute;
          transform: translate(-50%, -50%);
          left: 50%;
          top: 50%;
          height: px2rem(106);
          line-height: px2rem(90);
          font-size: px2rem(35);
          text-align: center;
        }
      }
      .get-identify-code {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: px2rem(30);
        border-radius: px2rem(50);
        background-color: rgb(255, 103, 82);
        width: px2rem(165);
        height: px2rem(50);
        font-size: px2rem(24);
        line-height: px2rem(50);
        text-align: center;
      }
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#newPay {
  position: relative;
  .content {
    width: px2rem(750);
    background-color: #fff4d5;
    .nav-bar {
      width: px2rem(750);
      height: px2rem(62);
      z-index: 2;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nav-bar-l {
        margin: 0 auto;
        img {
          width: px2rem(142);
        }
      }
      .nav-bar-r {
        display: flex;
        justify-content: space-between;
        width: px2rem(225);
        margin-right: px2rem(10);
        &:hover,
        &:active {
          text-decoration: none;
        }
        img {
          width: px2rem(30);
          height: px2rem(30);
        }
        h4 {
          display: inline-block;
          font-size: px2rem(28);
          color: #f54f50;
          letter-spacing: 0;
          line-height: px2rem(28);
        }
      }
    }
    .middle {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      max-width: px2rem(750);
      margin: 0 auto;
      .first {
        margin-bottom: px2rem(70);
        .img-box {
          width: px2rem(750);
          height: px2rem(530);
          overflow: hidden;
          z-index: 1;
          position: relative;
          .topban {
            width: px2rem(750);
            height: px2rem(555);
            object-fit: cover;
          }
          .bottom-image {
            width: px2rem(750);
            height: px2rem(46);
            background: url("https://web-data.zmlearn.com/image/jmovVfsP7SfcrKx9BWLUjn/banner_bottom.png")
              no-repeat center;
            background-size: cover;
            position: absolute;
            bottom: px2rem(-1);
            z-index: -100;
          }
        }
        .lesson-form-box {
          position: relative;
          margin-top: -1.1rem;
          z-index: 1;
        }
      }
      .second {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: px2rem(70);
        .title {
          background: url("https://web-data.zmlearn.com/image/qNvvErnfMtz7cHW7yc4fHA/newSection1Title.png")
            no-repeat center;
          background-size: contain;
          width: px2rem(669);
          height: px2rem(38);
          margin-bottom: px2rem(20);
        }
        .sectionTab {
          position: relative;
          top: 0;
          left: 0;
          margin-bottom: px2rem(20);
          .tabChange {
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            width: px2rem(690);
            height: px2rem(68);
            div {
              flex: 1;
              height: px2rem(68);
            }
          }
          .tab1 {
            width: px2rem(690);
            height: px2rem(554);
            background: url("https://web-data.zmlearn.com/image/9YtwTFyMdeZWGTA3b5zQD6/newSection1tab1.png")
              no-repeat center;
            background-size: contain;
          }
          .tab2 {
            width: px2rem(690);
            height: px2rem(554);
            background: url("https://web-data.zmlearn.com/image/7Qw94f8KepXrrF1jxfzeXN/newSection1tab2.png")
              no-repeat center;
            background-size: contain;
          }
          .tab3 {
            width: px2rem(690);
            height: px2rem(554);
            background: url("https://web-data.zmlearn.com/image/92bDaDXnohJfE2tukt7ksR/newSection1tab3.png")
              no-repeat center;
            background-size: contain;
          }
        }
      }
      .third {
        background: url("https://web-data.zmlearn.com/image/pYmE8QWXgjz4Lmhu8iKvm2/newSection2.png")
          no-repeat top center;
        background-size: contain;
        width: px2rem(687);
        height: px2rem(900);
        padding-top: px2rem(820);
        box-sizing: border-box;
      }
      .four {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: url("https://web-data.zmlearn.com/image/ecwaWaeqWyfcwY86qW7Kyf/newSection3Title.png")
          no-repeat top center;
        background-size: contain;
        width: px2rem(687);
        padding-top: px2rem(380);
        margin-bottom: px2rem(30);
        .swiper-box {
          height: px2rem(460);
          width: 100%;
          .intro1 {
            width: 100%;
            background: url("https://web-data.zmlearn.com/image/to7WcqoUzK6U2BA8f4BvD2/newSectionBan1.png")
              no-repeat top center;
          }
          .intro2 {
            width: 100%;
            background: url("https://web-data.zmlearn.com/image/bPofCK5jNv8Yn2kfDCzri1/newSectionBan2.png")
              no-repeat top center;
          }
        }
      }
      .btn-box {
        width: 100%;
        display: flex;
        justify-content: space-around;
        .listenBtn,
        .priceBtn {
          width: px2rem(325);
          height: px2rem(90);
        }
        .listenBtn {
          margin-right: px2rem(15);
        }
      }
      .slide-btn {
        position: fixed;
        z-index: 99;
        top: 50%;
        margin-top: 2rem;
        right: 0;
        transition: all 0.5s ease;
        display: block;
        transform: translateZ(0);
        img {
          display: block;
          width: px2rem(172);
          height: px2rem(125);
        }
      }
      .seventh {
        overflow: hidden;
        height: px2rem(152);
        .seventh-btn {
          width: px2rem(750);
          height: px2rem(152);
          bottom: 0;
          left: 0;
          background: url("https://web-data.zmlearn.com/image/erCoNzPJJZhKu8eHjaNDyR/new-pay1-footer.png")
            no-repeat center;
          background-size: cover;
          .btn-box {
            .btn-left {
              display: inline-block;
              width: px2rem(345);
              height: px2rem(90);
            }
            .btn-right {
              display: inline-block;
              width: px2rem(345);
              height: px2rem(90);
            }
          }
        }
        &.seventhFix {
          position: fixed;
          overflow: hidden;
          height: px2rem(148);
          bottom: 0;
          .seventh-btn {
            width: px2rem(750);
            height: px2rem(148);
            bottom: 0;
            left: 0;
            background: url("https://web-data.zmlearn.com/image/erCoNzPJJZhKu8eHjaNDyR/new-pay1-footer.png")
              no-repeat center;
            background-size: cover;
            .btn-box {
              .btn-left {
                display: inline-block;
                width: px2rem(345);
                height: px2rem(90);
              }
              .btn-right {
                display: inline-block;
                width: px2rem(345);
                height: px2rem(90);
              }
            }
          }
        }
      }
    }
  }
  .dialog-form {
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    .lesson-form-content {
      position: fixed;
      width: px2rem(664);
      height: px2rem(776);
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .lesson-form-box {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
      }
    }
  }
  .lesson-form-box {
    width: px2rem(664);
    margin: 0 auto;
  }
}
</style>
